import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { image_proof, okiee } from "../../../assets/img";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Select from "react-select";
import SingleTable from "../../../Component/Table/SingleTable";
import toast from "react-hot-toast";
import moment from "moment";
import { URLS } from "../../redux/api/Constants";
import { get, post } from "../../redux/api/ApiHandler";
import { userDetails } from "../../../Component/userDetails";
import SingleTable2 from "../../../Component/Table/SingleTable2";

const ViewInventory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const existingData = location.state?.data; // Prefill for edit/view
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
  const [pagination, setPagination] = useState("");
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [proof, setProof] = useState([]);
  const [popup, setPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [description, setDescription] = useState("");
  const [supportNeed, setSupportNeed] = useState("");
  const [regionId, setRegionId] = useState();
  const [customerId, setCustomerId] = useState();
  const [cusPrinterId, setCusPrinterId] = useState();
  const [servEngId, setServEngId] = useState();
  const [regManId, setRegManId] = useState();
  const [assigned, setAssigned] = useState([])


  const id = location?.state?.id;
  const tickType = location?.state?.tickType;
  const DispatchType = location?.state?.tickType == "Dispatch";
  const YetType = location?.state?.tickType == "Yet";
  // console.log("::", DispatchType);
  // console.log("::we", YetType);


  let user = userDetails();
  const admin_id = user?.id;
  const closeby = user?.name;
  const role = localStorage.getItem("role");

  const inventoryOptions = [
    { value: 9, label: "Dispatched" },
    { value: 5, label: "Technical" },
  ];

  const technicalOptions = [
    { value: 14, label: "Super Admin" },
    { value: 13, label: "Issue Resolved" },
    { value: 3, label: "Inventory" },
  ];



  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      employeeId: "",
      employeeName: "",
      email: "",
      mobile: "",
      role: "",
      status: "",
      trackingid: "",
      serialno: "",
      tickedclosed: closeby,

    },
  });

  const images = watch("images") || [];
  const video = watch("video") || null;
  const selectedStatus = watch("status");



  const viewAdmin = async () => {
    let res = await get(URLS.TICKET_VIEW + id)
    setList(res?.data?.customer_printer)

    if (res?.status === "success" && res?.data) {
      let data = res?.data?.ticket_details;
      let matched = null;

      if (role == "Inventory") {
        matched = data.find(item => item?.assigned_to?.role == 2);
      }
      if (role == "Technical") {
        matched = data.find(item => item?.assigned_to?.role == 3);
      }

      if (matched) {
        const assignedAt = matched.assigned_at;      // string
        const assignedTo = matched.assigned_to;      // object

        setValue("assigndate", moment(assignedAt).format("DD-MM-YYYY") || "-");
        setValue("assigntime", moment(assignedAt).format("hh:mm A") || "-");
        setValue("inventorydepart", assignedTo?.name || "-");
        setValue("chooseteam", assignedTo?.role === 2 ? "Inventory" : assignedTo?.role === 3 ? "Technical" : "-");
      }
    }


    if (res?.status === "success" && res?.data) {
      if (res?.status === "success" && res?.data) {
        const region_id = res?.data?.region?.id;
        const customer_id = res?.data?.customer?.id;
        const customer_printer_id = res?.data?.customer_printer?.id;
        const service_engineer_id = res?.data?.service_engineer?.id;
        const region_manager_id = res?.data?.regional_manager?.id;
        setRegionId(region_id);
        setCusPrinterId(customer_printer_id);
        setRegManId(region_manager_id);
        setServEngId(service_engineer_id);
        setCustomerId(customer_id);
      }
      const admin = res?.data;
      const admin_ticket = admin?.ticket_details?.[0];
      let spareType = admin_ticket?.spares?.map(item => item?.name)
      // setProof(admin?.ticket_details?.[0]?.proofs);

      // let ticket_data = admin?.ticket_details?.find(i => i?.proofs?.length > 0);
      // setProof(ticket_data?.proofs || []);
      const sorted = [...admin.ticket_details].sort(
        (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
      );
      const latestProofItem = sorted.find(i => i.proofs?.length > 0);
      setProof(latestProofItem?.proofs || []);

      // Assigned Loop
      const loopTable = admin?.ticket_details.filter(item => item?.moved_to == null)?.sort((a, b) => a.id - b.id) || [];
      const remainingLoop = loopTable.slice(1);
      setAssigned(remainingLoop);



      setValue("supportneed", admin_ticket?.support_needed == 1 ? "Technical" : admin_ticket?.support_needed == 2 ? "Inventory" : admin_ticket?.support_needed == 3 ? " Next Visit" : admin_ticket?.support_needed == 4 ? "Senior Support" : "-")
      setSupportNeed(admin_ticket?.support_needed)
      setValue("sparetype", spareType?.join(", "))
      setValue("faulttype", admin_ticket?.fault_type || "-")
      setValue("issueEngineer", admin_ticket?.issue_desc || "-")
      setValue("workdate", moment(admin_ticket?.closed_at).format("DD-MM-YYYY") || "-")
      setValue("worktime", moment(admin_ticket?.closed_at).format("hh:mm A") || "-")
      // console.log("admin_ticket", proof);
      setValue("region", admin?.region?.name || "-");
      setValue("regionalmanager", admin?.regional_manager?.name || "-");
      setValue("serviceengineer", admin?.service_engineer?.name || "-");
      setValue("customerID", admin?.customer?.code || "-");
      setValue("customername", admin?.customer?.name || "-");
      setValue("email", admin?.customer?.email || "-")
      setValue("mobile", admin?.customer?.mobile || "-")
      setValue("Secondarymobile", admin?.customer?.secondary_mobile || "-")
      setValue("address", admin?.customer?.address || "-")
      setValue("issue", admin?.customer_issue || "-")
      setValue("createdby", (admin?.created_by ? `${admin?.created_by?.name} - ${admin?.created_by?.role == 1 ? "Super Admin" : admin?.created_by?.role == 2 ? "Inventory" : admin?.created_by?.role == 3 ? "Technical Engineer" : admin?.created_by?.role == 4 ? "Regional Manager" : admin?.created_by?.role == 5 ? "Service Engineer" : "-"}` : "-"));
      setValue("createddate", moment(admin?.created_at).format("DD-MM-YYYY") || "-")
      setValue("opendate", moment(admin?.opened_at).format("DD-MM-YYYY") || "-")
      setValue("opentime", moment(admin?.opened_at).format("hh:mm A") || "-")
      setValue("pendingdate", moment(admin_ticket?.updated_at).format("DD-MM-YYYY") || "-")
      setValue("pendingtime", moment(admin_ticket?.updated_at).format("hh:mm:ss A") || "-")
      // setValue("assigndate", moment(admin_ticket?.assigned_at).format("DD-MM-YYYY") || "-")
      // setValue("assigntime", moment(admin_ticket?.assigned_at).format("hh:mm A") || "-")
      // setValue("inventorydepart", admin_ticket?.assigned_to?.name)
      // setValue("chooseteam", admin_ticket?.assigned_to?.role == 2 ? "Inventory" : "-")
      setValue("serialno", admin_ticket?.tracking?.serial_no || "")
      setValue("trackingid", admin_ticket?.tracking?.tracking_no || "")

      // setValue("status", admin?.current_status)

      // setValue("tickedclosed", closeby || "-")

    }
  }

  useEffect(() => {
    viewAdmin()
  }, [])


  const closeTicket = async () => {
    const formData = new FormData();
    const values = getValues();

    if (!values.status) {
      toast.error("Update Status");
      return;
    }
    if (values?.status == 9) {
      if (!values.trackingid) {
        toast.error("Enter Tracking Id");
        return;
      }
      if (!values.serialno) {
        toast.error("Enter Serial Number");
        return;
      }
      if (!values.images || values.images.length === 0) {
        toast.error("Upload at least one image");
        return;
      }

      if (values.images.length > 4) {
        toast.error("You can upload a maximum of 4 images");
        return;
      }
    }
    if (values?.status == 13) {
      if (!values.images || values.images.length === 0) {
        toast.error("Upload at least one image");
        return;
      }

      if (values.images.length > 4) {
        toast.error("You can upload a maximum of 4 images");
        return;
      }
    }


    // console.log("sttt", values?.status)
    // return;

    if (role === "Inventory") {
      if (values?.status == 9) {
        formData.append("status", 2);
        formData.append("support_needed", 2);
        formData.append("tracking_no", values?.trackingid);
        formData.append("serial_no", values?.serialno);
        formData.append("region_id", regionId);
        formData.append("regional_manager_id", regManId);
        formData.append("service_engineer_id", servEngId);
        formData.append("customer_printer_id", cusPrinterId);
        formData.append("customer_id", customerId);
        formData.append("current_status", values?.status);
        // formData.append("payload", JSON.stringify(payload));
        // console.log('images', values.images)
      }
      if (values?.status == 5) {
        formData.append("status", 2);
        formData.append("support_needed", 1);
        formData.append("region_id", regionId);
        formData.append("regional_manager_id", regManId);
        formData.append("service_engineer_id", servEngId);
        formData.append("customer_printer_id", cusPrinterId);
        formData.append("customer_id", customerId);
        formData.append("current_status", values?.status);
        formData.append("moved_to", 2);
      }
    }
    if (role === "Technical") {
      formData.append("status", 2);
      // formData.append("support_needed", 1);
      formData.append("region_id", regionId);
      formData.append("regional_manager_id", regManId);
      formData.append("service_engineer_id", servEngId);
      formData.append("customer_printer_id", cusPrinterId);
      formData.append("customer_id", customerId);
      formData.append("current_status", values?.status);
      if (values?.status == 14) {
        formData.append("moved_to", 1);
        formData.append("support_needed", 1);
      }
      if (values?.status == 3) {
        formData.append("moved_to", 3);
        formData.append("support_needed", 2);
      }
      if (values?.status == 13) {
        formData.append("support_needed", 1);
      }
    }



    if (values?.images) {
      values?.images.forEach((img, ind) => {
        if (img?.name) {
          formData.append(`images[${ind}]`, img)
        }
      })
    }
    if (values?.video?.name) {
      formData.append('video', video)
    }
    // let obj = {}
    // formData.forEach((key, values) => {
    //   obj[key] = values
    // })
    // console.log("obj", obj);

    let res = await post(URLS.TICKET_CLOSE + id, formData)
    if (res?.status == "success") {
      toast.success(res?.message);
      setPopup(false);
      navigate("/table-inventory");

    }
  }


  // useEffect(() => {
  //   if (existingData) {
  //     Object.entries(existingData).forEach(([key, value]) => {
  //       setValue(key, value);
  //     });
  //   }
  // }, [existingData, setValue]);



  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#1A77BC",
      minHeight: "40px",
      fontSize: "14px",
      backgroundColor: "#1978BC",
      color: "white",
      boxShadow: state.isFocused ? "0 0 0 1px #1978BC" : "none",
      "&:hover": {
        borderColor: "#1978BC",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white", // font color inside the selected value
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "white", // placeholder text color
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "white", // arrow icon color
      "&:hover": {
        color: "white",
      },
    }),
    input: (provided) => ({
      ...provided,
      color: "white", // text color while typing
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1978BC", // dropdown background
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#1A77BC" : "#1978BC",
      color: "white",
      "&:active": {
        backgroundColor: "#1565A6",
      },
    }),
  };


  // useEffect(() => {
  //   if (existingData) {
  //     Object.entries(existingData).forEach(([key, value]) => {
  //       setValue(key, value);
  //     });
  //   }
  // }, [existingData, setValue]);

  return (
    <div>
      <Topbar
        header="Inventory"
        subHead={isViewMode ? "View" : isEditMode ? "Edit" : "Add"}
      />
      <div className="container_fluit1 px-4 py-3">
        <form className="d-flex flex-wrap gap-5">
          <div className="col-md-5">
            <Controller
              control={control}
              name="region"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Region <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.region && (
                    <p style={{ color: "red" }}>{errors.region.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="regionalmanager"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Regional Manager <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.regionalmanager && (
                    <p style={{ color: "red" }}>
                      {errors.regionalmanager.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="serviceengineer"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Service Engineer <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.serviceengineer && (
                    <p style={{ color: "red" }}>
                      {errors.serviceengineer.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="customerID"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Customer ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.customerID && (
                    <p style={{ color: "red" }}>{errors.customerID.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="customername"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.customername && (
                    <p style={{ color: "red" }}>
                      {errors.customername.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Email */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="email"
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email format",
                },
              }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field} type="email"
                    className="input-box"
                    placeholder="Enter Email"
                    disabled
                  />
                  {errors.email && (
                    <p style={{ color: "red" }}>{errors.email.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Mobile */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="mobile"
              rules={{
                required: "Mobile number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Mobile number must be 10 digits",
                },
              }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Mobile Number<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Mobile Number"
                    disabled
                  />
                  {errors.mobile && (
                    <p style={{ color: "red" }}>{errors.mobile.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-5">
            <Controller
              control={control}
              name="Secondarymobile"
              rules={{
                required: "Mobile number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Mobile number must be 10 digits",
                },
              }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Secondary Number<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Mobile Number"
                    disabled
                  />
                  {errors.Secondarymobile && (
                    <p style={{ color: "red" }}>
                      {errors.Secondarymobile.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>

          <div className="col-md-11">
            <Controller
              control={control}
              name="address"
              rules={{ required: "Role is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Role"
                    disabled
                  />
                  {errors.address && (
                    <p style={{ color: "red" }}>{errors.address.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        </form>
        <label className="f3 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 mt-5">
          Printer Details
        </label>

        <div className="static-table-design">
          <table className=" table-border  static-table">
            <thead><tr className=" thfiled table_header">
              <th>S.No</th>
              <th>Printer ID</th>
              <th>Warrenty Start Date</th>
              <th>End Date</th>
              <th>AMC Start Date</th>
              <th>End Date</th>
            </tr></thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{list?.sr_no}
                  <img
                    src={okiee}
                    alt="printer"
                    width="20"
                    height="20"
                    style={{ objectFit: "contain" }}
                  />
                </td>
                <td>{moment(list?.wr_start_date).format("DD-MM-YYYY")}</td>
                <td>{moment(list?.wr_end_date).format("DD-MM-YYYY")}</td>
                <td>{moment(list?.amc_start_date).format("DD-MM-YYYY")}</td>
                <td>{moment(list?.amc_end_date).format("DD-MM-YYYY")}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <form className="d-flex flex-wrap gap-5">
          <div className="col-md-11 mt-5">
            <Controller
              control={control}
              name="issue"
              rules={{ required: "Role is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Issue Description By Customer{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Role"
                    disabled
                  />
                  {errors.issue && (
                    <p style={{ color: "red" }}>{errors.issue.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {tickType == "Dispatch" && (
            <div>
              <div className="col-lg-4">
                <label
                  className="f3 fs-sm-12 fs-md-17 fs-lg-18 fs-xl-19 fs-xxl-20 mb-2"
                  style={{ color: "#323691" }}
                >
                  Video Proof
                </label>
                {proof.map((item) => {
                  return (
                    <div>
                      {item?.status == "Video" && (
                        <video className="video-proof-box" width="300" height="200px" controls autoPlay={false} >
                          <source src={item?.file_url} type="video/mp4" />
                        </video>
                      )}
                    </div>
                  )
                })}
                {proof.length == 0 && (
                  <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">No Video proof Uploaded</p>
                )}
              </div>
              <div className="col-lg-6 ">
                <label
                  className="f3 fs-sm-12 fs-md-17 fs-lg-18 fs-xl-19 fs-xxl-20 mb-2"
                  style={{ color: "#323691" }}
                >
                  Image Proof
                </label>
                <div className="d-flex flex-wrap ac-js gap-3">
                  {proof.map((item, ind) => {
                    return (
                      <div key={ind}>
                        {item?.status == "Image" && (
                          <div >
                            <img role="button" onClick={() => setShowPopup(item?.file_url)} src={item?.file_url} className="image_proof" />

                          </div>
                        )}
                      </div>
                    )
                  })}

                  {proof.length == 0 && (
                    <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">No Image proof Uploaded</p>
                  )}
                </div>

              </div>
            </div>
          )}
          {role == "Inventory" && (
            <div className="col-md-5">
              <Controller
                control={control}
                name="sparetype"
                rules={{ required: "Employee ID is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Spare Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter Created by "
                      disabled
                    />
                    {errors.sparetype && (
                      <p style={{ color: "red" }}>{errors.sparetype.message}</p>
                    )}
                  </div>
                )}
              />
            </div>
          )}
          <div className="col-md-5">
            <Controller
              control={control}
              name="faulttype"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Fault Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Created by "
                    disabled
                  />
                  {errors.faulttype && (
                    <p style={{ color: "red" }}>{errors.faulttype.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-11 mt-3">
            <Controller
              control={control}
              name="issue"
              rules={{ required: "Role is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Issue Description By Service Engineer{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Role"
                    disabled
                  />
                  {errors.issue && (
                    <p style={{ color: "red" }}>{errors.issue.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="createdby"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Created by <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Created by "
                    disabled
                  />
                  {errors.createdby && (
                    <p style={{ color: "red" }}>{errors.createdby.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="createddate"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Created Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.createddate && (
                    <p style={{ color: "red" }}>{errors.createddate.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="opendate"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Open Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Created by "
                    disabled
                  />
                  {errors.opendate && (
                    <p style={{ color: "red" }}>{errors.opendate.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="opentime"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Open Time <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.opentime && (
                    <p style={{ color: "red" }}>{errors.opentime.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="pendingdate"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Pending Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Created by "
                    disabled
                  />
                  {errors.pendingdate && (
                    <p style={{ color: "red" }}>{errors.pendingdate.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="pendingtime"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Pending Time <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.pendingtime && (
                    <p style={{ color: "red" }}>{errors.pendingtime.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="chooseteam"
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Choose the Team <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder=""
                    disabled
                  />
                  {errors.chooseteam && (
                    <p style={{ color: "red" }}>{errors.chooseteam.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="inventorydepart"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    {role == "Inventory" ? "Inventory" : role == "Technical" ? "Technical" : ""}   Department <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.inventorydepart && (
                    <p style={{ color: "red" }}>
                      {errors.inventorydepart.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="assigndate"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Assign Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.assigndate && (
                    <p style={{ color: "red" }}>{errors.assigndate.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div className="col-md-5">
            <Controller
              control={control}
              name="assigntime"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Assign Time <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled
                  />
                  {errors.assigntime && (
                    <p style={{ color: "red" }}>{errors.assigntime.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {assigned.map((item) => {
            let support = item?.support_needed
            return (
              <div className="d-flex flex-wrap gap-5 w-100">
                <div className="col-md-5">
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Support Need<span style={{ color: "red" }}>*</span>
                  </label>
                  <Controller
                    control={control}
                    name="supportneed"
                    rules={{ required: "Coupon Type is required" }}
                    render={({ field }) => (
                      <div>
                        <input
                          value={support == 1 ? "Technical" : support == 2 ? "Inventory" : support == 3 ? " Next Visit" : support == 4 ? "Senior Support" : support == 5 ? "Work Completed" : "-"}
                          className="input-box"
                          placeholder="Enter Status"
                          disabled={true}
                          style={{ backgroundColor: "#1978BC", color: "white" }}
                        />
                      </div>
                    )}
                  />
                </div>
                <div className="col-md-5">
                  <Controller
                    control={control}
                    name="pendingtime"
                    rules={{ required: "Employee ID is required" }}
                    render={({ field }) => (
                      <div>
                        <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                          {support == 1 ? "Technical" : support == 2 ? "Inventory" : support == 3 ? " Next Visit" : support == 4 ? "Senior Support" : support == 5 ? "Work Completed" : "-"} Assign Date <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={moment(item?.assigned_at).format("DD-MM-YYYY")}
                          className="input-box"
                          placeholder="Enter Employee ID"
                          disabled
                        />
                        {errors.opentime && (
                          <p style={{ color: "red" }}>{errors.opentime.message}</p>
                        )}
                      </div>
                    )}
                  />
                </div>
                <div className="col-md-5">
                  <Controller
                    control={control}
                    name="pendingtime"
                    rules={{ required: "Employee ID is required" }}
                    render={({ field }) => (
                      <div>
                        <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                          {support == 1 ? "Technical" : support == 2 ? "Inventory" : support == 3 ? " Next Visit" : support == 4 ? "Senior Support" : support == 5 ? "Work Completed" : "-"} Assign Time <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={moment(item?.assigned_at).format("hh:mm A")}
                          className="input-box"
                          placeholder="Enter Employee ID"
                          disabled
                        />
                        {errors.opentime && (
                          <p style={{ color: "red" }}>{errors.opentime.message}</p>
                        )}
                      </div>
                    )}
                  />
                </div>
                <SingleTable2 WorkCompleted={item} />
              </div>
            )
          })}

          {isEditMode && (
            <div className="col-md-5">
              <Controller
                control={control}
                name="status"
                rules={{ required: "Status is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Status <span style={{ color: "red" }}>*</span>
                    </label>

                    {/* {isEditMode ? ( */}
                    <Select
                      name="status"
                      {...field}
                      options={role == "Inventory" ? inventoryOptions : technicalOptions}
                      value={inventoryOptions.find(
                        (option) => option.value === field.value
                      )}
                      onChange={(selectedOption) => field.onChange(selectedOption.value)}
                      placeholder="Select Status"
                      isSearchable
                      isDisabled={isViewMode}
                      styles={customStyles}
                    />
                    {/* // ) : (
                  //   <input
                    //     {...field}
                    //     className="input-box"
                    //     placeholder="Enter Status"
                    //     disabled={true}
                    //   />
                    // )} */}

                    {errors.status && (
                      <p style={{ color: "red" }}>{errors.status.message}</p>
                    )}
                  </div>
                )}
              />
            </div>
          )}

          {/* {data?.ticketType == "Support" && (
            <div className="col-md-5">
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Support Need
              </label>
              <Controller
                control={control}
                name="supportneed"
                rules={{ required: "Coupon Type is required" }}
                render={({ field }) => (
                  <div>
                    <input
                      {...field}
                      className="input-box"
                      disabled={true}
                      style={{ backgroundColor: "#1978BC", color: "white" }}
                    />
                  </div>
                )}
              />
            </div>
          )} */}
          {selectedStatus === 9 && (
            <div className="col-md-5">
              <Controller
                control={control}
                name="trackingid"
                rules={{
                  // required:
                  // statusValue === "dispatch"
                  // ? "Tracking ID is required when status is Dispatch"
                  // : false,
                }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Tracking ID{" "}
                      {/* {statusValue === "dispatch" && (
                        <span style={{ color: "red" }}>*</span>
                      )} */}
                    </label>
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter Tracking ID"
                      disabled={isViewMode}
                    // disabled={isViewMode || statusValue !== "dispatch"}
                    />
                    {errors.trackingid && (
                      <p style={{ color: "red" }}>
                        {errors.trackingid.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
          )}
          {selectedStatus === 9 && (
            <div className="col-md-5">
              <Controller
                control={control}
                name="serialno"
                rules={{
                  // required:
                  // statusValue === "dispatch"
                  // ? "Tracking ID is required when status is Dispatch"
                  // : false,
                }}
                render={({ field }) => (
                  <div>
                    <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Serial Number{" "}
                      {/* {statusValue === "dispatch" && (
                        <span style={{ color: "red" }}>*</span>
                      )} */}
                    </label>
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter Serial Number"
                      disabled={isViewMode}
                    // disabled={isViewMode || statusValue !== "dispatch"}
                    />
                    {errors.trackingid && (
                      <p style={{ color: "red" }}>
                        {errors.trackingid.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
          )}

          {tickType == "Yet" && (selectedStatus == 9 || selectedStatus == 13) && (
            <div>
              <div className="">
                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">Upload Images (Max 4)</label>
                <input
                  name="images"
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => {
                    let files = Array.from(e.target.files);

                    // Prevent user from adding more than 4
                    if (files.length + images.length > 4) {
                      toast.error("You can upload maximum 4 images only.");
                      return;
                    }

                    setValue("images", [...images, ...files]);
                  }}
                />

                {/* Show Previews */}
                <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                  {images.map((img, index) => (
                    <div key={index}>
                      <img
                        src={URL.createObjectURL(img)}
                        width={80}
                        height={80}
                        style={{ borderRadius: 6, objectFit: "cover" }}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setValue(
                            "images",
                            images.filter((_, i) => i !== index)
                          )
                        }
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ marginTop: "20px" }}>
                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">Upload Video (Max 1)</label>
                <input
                  name="video"
                  type="file"
                  accept="video/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    // Ensure only 1 video allowed
                    if (video) {
                      alert("You can upload only 1 video.");
                      return;
                    }

                    setValue("video", file);
                  }}
                />

                {/* Show Preview (optional) */}
                {video && (
                  <div style={{ marginTop: "10px" }}>
                    <video
                      width="200"
                      height="120"
                      controls
                      src={URL.createObjectURL(video)}
                    />
                    <br />
                    <button type="button" onClick={() => setValue("video", null)}>
                      Remove Video
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </form>


        {/* <SingleTable /> */}

        {/* {!isViewMode && (
          <>
            <div className="col-md-5">
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Support Need<span style={{ color: "red" }}>*</span>
              </label>
              <Controller
                control={control}
                name="supportneed"
                rules={{ required: "Coupon Type is required" }}
                render={({ field }) => (
                  <div>
                    <Select
                      {...field}
                      options={couponOptions}
                      placeholder="Inventory"
                      isSearchable
                      onChange={field.onChange}
                      value={field.value}
                      styles={customStyles}
                      isDisabled={isViewMode}
                    />
                    {errors.supportneed && (
                      <p style={{ color: "red" }}>
                        {errors.supportneed.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
          </>
        )} */}

        {/* Buttons */}
        <div className="d-flex col-md-11 ac-jb my-5">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>
          {!isViewMode && (
            <div className="d-flex ac-jc gap-4">
              <button
                type="submit"
                onClick={closeTicket}
                className="move_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 d-flex ac-js">
              Assign Date
            </label>
            <textarea
              placeholder="-Enter Issue Type-"
              className="form-control f2 fs-sm-13 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-15"
              style={{
                borderRadius: "8px",
                borderColor: "#D9D9D9",
                width: "100%",
                minHeight: "100px",
                padding: "10px",
                fontSize: "10px",
                resize: "vertical",
                outline: "none",
              }}
              disabled={isViewMode}
            />

            <div className="my-3">
              <Controller
                control={control}
                name="tickedclosed"
                render={({ field }) => (
                  <div>
                    <label className="f3 d-flex ac-js fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                      Ticket Closed By
                    </label>
                    <input
                      {...field}
                      className="input-box"
                      disabled={isViewMode}
                    />
                    {errors.tickedclosed && (
                      <p style={{ color: "red" }}>
                        {errors.tickedclosed.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="d-flex ac-je">
              <button
                onClick={() => setPopup(false)}
                className="yes-btn f2 w-40  "
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewInventory;
